import { Link } from "@inertiajs/react";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CALENDLY_COST_REVIEW_URL } from "@/lib/urls";

interface CallToActionProps {
  heading?: string;
  subheading?: string;
}

const TRUST_POINTS = [
  "No credit card required",
  "Read-only IAM role",
  "Your team reviews and merges every change",
] as const;

export function CallToAction({
  heading = "Put your AWS cost savings on autopilot",
  subheading = "Infralyst continuously analyzes your AWS resources and opens Terraform PRs to fix what it finds. Your team reviews and merges.",
}: CallToActionProps): React.ReactElement {
  return (
    <section className="py-24 bg-primary text-primary-foreground -mx-4">
      <div className="max-w-4xl mx-auto text-center px-4">
        <h2 className="text-4xl font-bold mb-6">{heading}</h2>
        <p className="text-xl text-primary-foreground/80 mb-8">{subheading}</p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button asChild size="xl" className="bg-white text-primary font-semibold hover:bg-white/90">
            <Link href="/signup">
              Start free with 3 PRs
            </Link>
          </Button>
          <Button asChild variant="outline" size="xl" className="border-white/30 bg-transparent text-primary-foreground font-semibold shadow-none hover:border-white/60 hover:bg-white/10 hover:text-primary-foreground dark:bg-transparent dark:border-white/30 dark:hover:bg-white/10 dark:hover:border-white/60">
            <a
              href={CALENDLY_COST_REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Book a demo
            </a>
          </Button>
        </div>
        <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-4">
          {TRUST_POINTS.map((point) => (
            <li key={point} className="flex items-center gap-1.5 text-sm text-primary-foreground/70">
              <CheckCircle className="size-3.5 text-primary-foreground/70 flex-none" />
              {point}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
